import { httpClient } from "funcs"

const isAuthorized = () => {
  return httpClient.defaults.headers['Authorization'] ? true : false
}


export default isAuthorized